import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldAlert } from "lucide-react";

export default function AlertsPage() {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/alerts").then(r => { setAlerts(r.data); setLoading(false); }); }, []);

  return (
    <div className="space-y-6" data-testid="alerts-page">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 font-semibold">Warnungen</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1 flex items-center gap-3">
          <ShieldAlert className="h-7 w-7" /> Wo brennt es?
        </h1>
        <p className="text-sm text-neutral-500 mt-2">Automatische Empfehlungen basierend auf deinem aktuellen Cashflow.</p>
      </div>

      {loading ? <div className="text-neutral-500">Lade…</div> :
        alerts.length === 0 ? (
          <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-8 text-center text-emerald-800" data-testid="alerts-empty">
            🎉 Alles bestens — keine Warnungen.
          </div>
        ) : (
          <div className="grid gap-3" data-testid="alerts-list">
            {alerts.map((a, i) => (
              <div key={i} className="rounded-xl border border-neutral-200 bg-white p-5 flex gap-4 items-start hover:border-neutral-300 transition-colors" data-testid={`alert-item-${i}`}>
                <div className={`h-2.5 w-2.5 rounded-full mt-2 shrink-0`} style={{ backgroundColor: a.severity === "red" ? "#EF4444" : a.severity === "yellow" ? "#F59E0B" : "#3B82F6" }} />
                <div className="flex-1">
                  <div className="font-display font-semibold text-neutral-900">{a.title}</div>
                  <div className="text-sm text-neutral-600 mt-1">{a.message}</div>
                </div>
                <span className="text-[10px] uppercase tracking-wider font-bold px-2 py-0.5 rounded"
                  style={{
                    color: a.severity === "red" ? "#991B1B" : a.severity === "yellow" ? "#92400E" : "#1E40AF",
                    backgroundColor: a.severity === "red" ? "#FEE2E2" : a.severity === "yellow" ? "#FEF3C7" : "#DBEAFE",
                  }}>
                  {a.severity === "red" ? "Kritisch" : a.severity === "yellow" ? "Achtung" : "Info"}
                </span>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
